import { createAction, props } from '@ngrx/store';

import {
  GoogleAuthSetupResponse,
  ResetPasswordPayload,
  ResetPasswordResponse,
  VerifyGoogleAuthSetupResponse,
  ResetGoogleAuthInitiateResponse,
} from '../models/account-security.model';

export const googleAuthStartSetup = createAction(
  '[Account Security] Google Auth - Start Setup'
);

export const googleAuthStartSetupSuccess = createAction(
  '[Account Security] Google Auth - Start Setup Success',
  props<{ response: GoogleAuthSetupResponse }>()
);

export const googleAuthStartSetupFailure = createAction(
  '[Account Security] Google Auth - Start Setup Failure',
  props<{ error: string }>()
);

export const resetGoogleAuthInitiate = createAction(
  '[Account Security] Reset Google Auth - Initiate'
);

export const resetGoogleAuthInitiateSuccess = createAction(
  '[Account Security] Reset Google Auth - Initiate Success',
  props<{ response: ResetGoogleAuthInitiateResponse }>()
);

export const resetGoogleAuthInitiateFailure = createAction(
  '[Account Security] Reset Google Auth - Initiate Failure',
  props<{ error: string }>()
);

export const resetGoogleAuthResendOtp = createAction(
  '[Account Security] Reset Google Auth - Resend OTP'
);

export const resetGoogleAuthResendOtpSuccess = createAction(
  '[Account Security] Reset Google Auth - Resend OTP Success',
  props<{ response: ResetGoogleAuthInitiateResponse }>()
);

export const resetGoogleAuthResendOtpFailure = createAction(
  '[Account Security] Reset Google Auth - Resend OTP Failure',
  props<{ error: string }>()
);

export const resetGoogleAuthVerifyOtp = createAction(
  '[Account Security] Reset Google Auth - Verify OTP',
  props<{ otp: string }>()
);

export const resetGoogleAuthVerifyOtpSuccess = createAction(
  '[Account Security] Reset Google Auth - Verify OTP Success',
  props<{ token: string }>()
);

export const resetGoogleAuthVerifyOtpFailure = createAction(
  '[Account Security] Reset Google Auth - Verify OTP Failure',
  props<{ error: string }>()
);

export const closeSuccess = createAction('[Account Security] Close Success');

export const resetPassword = createAction(
  '[Account Security] Reset Password',
  props<{ userId: string; payload: ResetPasswordPayload }>()
);

export const resetPasswordSuccess = createAction(
  '[Account Security] Reset Password Success',
  props<{ response: ResetPasswordResponse }>()
);

export const resetPasswordFailure = createAction(
  '[Account Security] Reset Password Failure',
  /** `errorCode` is user-management's, e.g. INVALID_CURRENT_PASSWORD (F-012). */
  props<{ error: string; errorCode?: string | null }>()
);

export const logoutAfterPasswordChange = createAction(
  '[Account Security] Logout After Password Change'
);

export const resetGoogleAuthFetchQrCode = createAction(
  '[Account Security] Reset Google Auth - Fetch QR Code',
  props<{ token: string }>()
);

export const resetGoogleAuthFetchQrCodeSuccess = createAction(
  '[Account Security] Reset Google Auth - Fetch QR Code Success',
  props<{ response: GoogleAuthSetupResponse }>()
);

export const resetGoogleAuthFetchQrCodeFailure = createAction(
  '[Account Security] Reset Google Auth - Fetch QR Code Failure',
  props<{ error: string }>()
);

// ============================================
// COMMON ACTIONS (used by both flows)
// ============================================
export const googleAuthVerifyOtp = createAction(
  '[Account Security] Google Auth - Verify OTP',
  props<{ otp: string }>()
);

export const googleAuthVerifyOtpSuccess = createAction(
  '[Account Security] Google Auth - Verify OTP Success',
  props<{ response: VerifyGoogleAuthSetupResponse }>()
);

export const googleAuthVerifyOtpFailure = createAction(
  '[Account Security] Google Auth - Verify OTP Failure',
  props<{ error: string }>()
);

export const googleAuthProceedToOtp = createAction(
  '[Account Security] Google Auth - Proceed To OTP'
);

export const googleAuthBackToQr = createAction(
  '[Account Security] Google Auth - Back To QR'
);

export const googleAuthBackToOtp = createAction(
  '[Account Security] Google Auth - Back To OTP'
);

export const googleAuthRequestCancelSetup = createAction(
  '[Account Security] Google Auth - Request Cancel Setup',
  props<{ origin: 'qr' | 'otp' | 'resetOtp' }>()
);

export const googleAuthDismissCancelSetup = createAction(
  '[Account Security] Google Auth - Dismiss Cancel Setup'
);

export const googleAuthCancelSetup = createAction(
  '[Account Security] Google Auth - Cancel Setup'
);

export const googleAuthCloseSuccess = createAction(
  '[Account Security] Google Auth - Close Success'
);
